import AITextCompletion from 'models/ai_text_completion';
import CreateToast from 'scripts/application/actions/toast/create_toast';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import Language from 'models/language';
import { translateText, getErrorToastParams } from 'scripts/application/actions/lib/ai_translate';
import Translation from 'scripts/domain/models/translation';
import TranslationRequest from 'scripts/domain/models/translation_request';

export default class TranslateComposition {
  constructor(context) {
    this.context = context;
  }

  run(params) {
    const { composition, html, requestorId, text, targetLanguage, customerId } = params;
    const { aiTextCompletions, compositions, customerLanguage } = this.context.stores.customers.storesFor(customerId);

    aiTextCompletions.setLoading({ id: requestorId });
    aiTextCompletions.clearErrorForLoading({ id: requestorId });

    customerLanguage.set(Language.create({ id: 'customer-language', code: targetLanguage }));

    const translationRequest = TranslationRequest.create({
      compositionId: composition.id,
      conversationId: composition.conversationId,
      text: html || text,
      targetLanguage,
    });

    return translateText(customerId, this.context, translationRequest)
      .then(responseDto => {
        if (!responseDto) {
          return;
        }

        // The text entered by the agent is saved in the 'translation' object
        // The parent content will be replaced by the response to send to customer.
        const translation = Translation.create({
          content: html || text,
          contentLanguage: responseDto.sourceLanguage,
          parentLanguage: responseDto.targetLanguage,
          model: responseDto.model,
          provider: responseDto.provider,
          translatedAt: responseDto.translatedAt,
        });

        composition.replaceTranslation(translation);
        compositions.replace(composition);
        this.context.stores.localCompositions.set(customerId, composition);

        this.context.analytics.track('Composition Translated', {
          customerId,
          compositionId: composition.id,
          sourceLanguage: responseDto.sourceLanguage,
          targetLanguage: responseDto.targetLanguage,
          model: responseDto.model,
          provider: responseDto.provider,
        });

        // Render the text completion bubble with the content in it.
        const completionParams = {
          data: {
            initialText: text,
            customerId,
            requestorId,
            text: responseDto.text,
            targetLanguage,
          },
          id: requestorId,
          rewriteId: IdGenerator.newId(),
          type: AITextCompletion.Types.translate,
        };
        const result = AITextCompletion.create(completionParams);
        aiTextCompletions.addOrReplace(result);

        return translation;
      })
      .catch(err => {
        const toastParams = getErrorToastParams(err);
        this.context.executeAction(CreateToast, toastParams);
      })
      .finally(() => {
        aiTextCompletions.resetLoading({ id: requestorId });
      });
  }
}
